"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSocialNetworkLink = getSocialNetworkLink;
var _helpers = require("./helpers.js");
const generators = {
  email: params => {
    const {
      url,
      text = '',
      longtext = ''
    } = params;
    return `mailto:${(0, _helpers.objectToGetParams)({
      subject: text,
      body: `${longtext} \n\n» ${url}`
    })}`;
  },
  facebook: params => {
    const {
      url,
      text = '',
      longtext = '',
      hashtag = ''
    } = params;
    return `https://www.facebook.com/sharer/sharer.php${(0, _helpers.objectToGetParams)({
      u: url,
      quote: text || longtext ? `${text} \n${longtext}` : '',
      hashtag
    })}`;
  },
  twitter: params => {
    const {
      url,
      text = '',
      via = '',
      hashtags = []
    } = params;
    return `https://twitter.com/share${(0, _helpers.objectToGetParams)({
      url,
      text,
      via,
      hashtags: hashtags.join(',')
    })}`;
  },
  googleplus: params => {
    const {
      url
    } = params;
    return `https://plus.google.com/share${(0, _helpers.objectToGetParams)({
      url
    })}`;
  },
  linkedin: params => {
    const {
      url,
      text = '',
      longtext = ''
    } = params;
    return `https://linkedin.com/shareArticle${(0, _helpers.objectToGetParams)({
      url,
      title: text,
      summary: longtext
    })}`;
  },
  pinterest: params => {
    const {
      media,
      text = ''
    } = params;
    return `https://pinterest.com/pin/create/button/${(0, _helpers.objectToGetParams)({
      media,
      description: text
    })}`;
  }
};

/**
 * Check that a network is setup in the 
 * generators  object
 * 
 * @param {string} key 
 * @returns {boolean}
 */
function isValidNetwork(key) {
  return generators.hasOwnProperty(key) ? true : false;
}

/**
 * 
 * 
 * @param {object} params - {network, url, media, ...rest} 
 * @returns {string}
 */
function getSocialNetworkLink(params) {
  const {
    network,
    ...rest
  } = params;
  const {
    url,
    media
  } = rest;
  const key = network.toLowerCase();
  if (!key) throw new Error(`the ShareButton's 'network' prop can't be undefined`);
  if (!isValidNetwork(key)) throw new Error(`the 'network' prop's value is not a valid value for ShareButton`);
  if (!url) throw new Error(`the ShareButton's 'url' prop can't be undefined`);
  if (network === 'Pinterest' && !media) throw new Error(`the ShareButton's 'media' prop for the 'Pinterest' network can't be undefined`);
  return generators[key](rest);
}